import { render, staticRenderFns } from "./inventory-min-max-2.vue?vue&type=template&id=6db32ee0&"
import script from "./inventory-min-max-2.vue?vue&type=script&lang=js&"
export * from "./inventory-min-max-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports